module.exports = __webpack_public_path__ + "app/assets/img/leds/liquidfeedback.png";